import React, { useEffect, useState, useRef, useCallback } from "react";

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as SearchIcon } from "../../assets/svg/search.svg";
import { ReactComponent as EditIcon } from "../../assets/svg/edit-icon.svg";
import { ReactComponent as OfficeIcon } from "../../assets/svg/office-icon.svg";
import { ReactComponent as MoreIcon } from "../../assets/svg/more-icon.svg";
import { ReactComponent as ImageRemoveIcon } from "../../assets/svg/delete-img.svg";

import RoomImage from "../../assets/png/room-image.png";
import SearchWithAPI from "../searchbox/searchbox";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, parse } from "date-fns";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form, Button, InputGroup, Toast, ToastContainer } from "react-bootstrap";
import Header from "../common/Header";
import "./material-style.css";
import "./room-style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "flatpickr/dist/flatpickr.min.css";
import flatpickr from "flatpickr";
import { getCookie } from "../getcookie.js";
import LoaderModal from "../common/Loader.js";
import { ReactComponent as NoRecordsFound } from "../../assets/svg/no-records-found.svg";
import { useGlobal } from "../../GlobalContext";
import DeleteModal from "../common/delete-modal.js";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import ReactPaginate from "react-paginate";
export default function RoomList() {
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const navigate = useNavigate();

  const scrollRefs = useRef([]);
  const alertRef = useRef(null);
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const scrollLeft = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: -100, behavior: "smooth" });
    }
  };
  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  const scrollRight = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: 100, behavior: "smooth" });
    }
  };
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
  };

  const [selectedTap, setTapValue] = useState("upcoming");

  const [floorSearchUrl, setFloorSearchUrl] = useState("");

  const [errorMessage, setErrorMessage] = useState({ name: "", office_id: "", floor_no: "", category: "" });
  const [roomId, setRoomId] = useState("");
  const [codeInputValue, setCodeInputValue] = useState("");
  const [nameInputValue, setNameInputValue] = useState("");
  const [selectedOffice, setOfficeValue] = useState("");
  const [selectedOfficeLabel, setOfficeLabel] = useState("");
  const [selectedFloor, setFloorValue] = useState("");
  const [selectedFloorLabel, setFloorLabel] = useState("");
  const [selectedOfficeOption, setSelectedOfficeOption] = useState(null);
  const [selectedFloorOption, setSelectedFloorOption] = useState(null);
  const [categoryInputValue, setCategoryInputValue] = useState("");
  const [capacityInputValue, setCapacityInputValue] = useState(0);

  const [availableFeatureValue, setAvailableFeatureValue] = useState("");
  const [availableFeatureList, setAvailableFeatureList] = useState([]);
  const [officeDetail, setOfficeDetail] = useState({});
  const [showPicker, setShowPicker] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const [base64File, setBase64File] = useState(null);
  const [selectedImageList, setSelectedImageList] = useState([]);
  const [base64FileList, setBase64FileList] = useState([]);
  const [urlImageList, setUrlImageList] = useState([]);

  const [orgImage, setOrgImg] = useState("");
  const [selectedCategory, setCategoryValue] = useState("");
  const [selectedSlot, setSlotValue] = useState("30 mins");
  const [selectedBookId, setBookId] = useState([]);
  const [bookIdList, setBookIdList] = useState([]);
  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);

  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const openModal = (id, index) => {
    setRoomIndex(index);
    setRoomId(id);
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    setErrorMessage({ name: "", office_id: "", floor_no: "", category: "" });
    setRoomId(null);
    setCodeInputValue("");
    setNameInputValue("");
    setOfficeValue("");
    setOfficeLabel("");
    setFloorValue("");
    setFloorLabel("");
    setCategoryInputValue("");
    setCapacityInputValue(0);
    setAvailableFeatureValue("");
    setAvailableFeatureList([]);
    setSelectedOfficeOption(null);
    setSelectedFloorOption(null);
  };



  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [upcomingCount, setUpcomingCount] = useState(0);
  const [pastCount, setPastCount] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [alertIndex, setAlertIndex] = useState(null);
  const [time, setTime] = useState("");
  const [rolePermissionList, setRolePermissionList] = useState([]);
  const [userType, setUserType] = useState("");

  const handleChange = (event) => {
    setTime(event.target.value);
  };
  const menuBoxInactive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center" };
  const menuBoxActive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234" };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#842234" };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: "#1E1E1E" };
  const profileName = { fontSize: "14px", fontWeight: "700", color: "#842234" };
  const title = { fontSize: "24px", fontWeight: "800", color: "#1E1E1E" };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: "#81878C" };
  const roomTitle = { fontSize: "15px", fontWeight: "700", color: "#1E1E1E" };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: "#81878C", marginTop: "8px" };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: "#81878C", marginBottom: "8px" };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: "#21272C" };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: "#1E1E1E" };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: "#842234" };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: "#1E1E1E" };
  const officeTitle = { marginTop: "16px", marginBottom: "8px", fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#1E1E1E" };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "677px",
      height: "500px",
      textAlign: "center",
      overflowY: "auto",
    },
  };

  const handleCategoryClick = (category) => {
    setCategoryValue(category);
  };

  useEffect(() => {
    flatpickr("#flatpickr-time", {
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
    });
  }, []);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setSelectedMenu("Rooms");
    fetchOptions("");
    getRolePermission();
  }, []);
  const getRolePermission = async () => {
    try {
      const response = await axios
        .get(adminApiUrl + "get_role_permission/27", {
          params: {},
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",

            "Access-Control-Allow-Origin": "*", // Required for CORS support to work
            Authorization: getCookie("mawalog"),
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.success === true) {
              setUserType(response.data.user_type);
              setRolePermissionList(response.data.role_permission ?? []);
            } else {
              setRolePermissionList([]);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 500 || error.response.status === 400) {
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });

      // const data = await response.json();
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
    }
  };

  useEffect(() => {
    console.log("errorMessage.....", errorMessage);
  }, [errorMessage]);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    console.log("Searching for:", term);
    fetchOptions(term);
  }, 1000);
  useEffect(() => {

    fetchOptions("");

  }, [itemOffset, itemsPerPage]);
  const fetchOptions = async (term) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(apiUrl + `room`, {
        params: { search: term, skip: itemOffset, limit: itemsPerPage },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",

          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          Authorization: getCookie("mawalog"),
        },
      });

      // const data = await response.json();
      if (response.data.success === true) {
        if (response.data.rooms.length > 0) {
          setRooms(response.data.rooms);
          setTotalCount(response.data.total_rec ?? 0);
          setPageCount(response.data.total_pgs);
          console.log("Room List:", roomList);
          console.log("Room List Length:", roomList.length);
        } else {
          setRooms([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const editOffice = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(apiUrl + `room/` + id, {
        params: {},
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",

          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          Authorization: getCookie("mawalog"),
        },
      });

      // const data = await response.json();
      if (response.data.success === true) {
        setIsOpen(true);
        if (response.data.room) {
          setUrlImageList(response.data.room.images ?? []);
          setRoomId(response.data.room.id);
          setCodeInputValue(response.data.room.code);
          setNameInputValue(response.data.room.name);
          setOfficeValue(response.data.room.office_id);
          setOfficeLabel(response.data.room.office);
          setFloorValue(response.data.room.floor_no);
          setFloorLabel(response.data.room.floor_label);
          setCategoryInputValue(response.data.room.category);
          setCapacityInputValue(parseInt(response.data.room.capacity, 0));
          setAvailableFeatureList(response.data.room.features);
        } else {
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const submitOffice = async () => {
    const data = {
      name: nameInputValue,
      office_id: selectedOffice,
      floor_no: selectedFloor,
      capacity: capacityInputValue,
      category: categoryInputValue,
      images: base64FileList,
      features: availableFeatureList,
    };

    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: getCookie("mawalog"),
    };
    const response = await axios
      .post(apiUrl + "room", data, { headers: headers })
      .then((response) => {
        console.log("Response status:", response.status); // Check actual status
        console.log("Response data:", response.data);
        if (response.status === 200) {
          if (response.data.success === true) {
            closeModal();
            fetchOptions("");
            setSnackbarMessage(response.data.message);
            setSnackbarStatus(response.data.success);
            handleSnackbarShow();
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 400) {
            var errorMsg = error.response.data.error;
            setErrorValue(error.response.data.error);
            console.log("error msg", errorMsg);
          }
        } else {
          console.error("Request failed:", error.message);
        }
      });
  };

  const updateOffice = async () => {
    console.log("get_slots api called");
    const data = {
      name: nameInputValue,
      office_id: selectedOffice,
      floor_no: selectedFloor,
      capacity: capacityInputValue,
      category: categoryInputValue,
      images: base64FileList,
      features: availableFeatureList,
    };

    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: getCookie("mawalog"),
    };
    const response = await axios
      .put(apiUrl + "room/" + roomId, data, { headers: headers })
      .then((response) => {
        console.log("Response status:", response.status); // Check actual status
        console.log("Response data:", response.data);
        if (response.status === 200) {
          if (response.data.success === true) {
            closeModal();
            fetchOptions("");
            setSnackbarMessage(response.data.message);
            setSnackbarStatus(response.data.success);
            handleSnackbarShow();
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 400) {
            var errorMsg = error.response.data.error;
            setErrorValue(error.response.data.error);
            console.log("error msg", errorMsg);
          }
        } else {
          console.error("Request failed:", error.message);
        }
      });
  };

  const deleteOffice = async (id) => {
    console.log("get_slots api called");

    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: getCookie("mawalog"),
    };
    const response = await axios
      .delete(
        apiUrl + "room/" + id,

        { headers: headers }
      )
      .then((response) => {
        console.log("Response status:", response.status); // Check actual status
        console.log("Response data:", response.data);
        if (response.status === 200) {
          if (response.data.success === true) {
            setAlertIndex(null);
            fetchOptions("");
            setSnackbarMessage(response.data.message);
            setSnackbarStatus(response.data.success);
            handleSnackbarShow();
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 400) {
            var errorMsg = error.response.data.error;

            console.log("error msg", errorMsg);
          }
          setSnackbarMessage(error.response.data.message);
          setSnackbarStatus(error.response.data.success);
          handleSnackbarShow();
        } else {
          console.error("Request failed:", error.message);
        }
      });
  };

  const setErrorValue = async (errorMsg) => {
    setErrorMessage({
      name: errorMsg["name"] !== undefined ? errorMsg["name"][0] : "",
      office_id: errorMsg["office_id"] !== undefined ? errorMsg["office_id"][0] : "",
      floor_no: errorMsg["floor_no"] !== undefined ? errorMsg["floor_no"][0] : "",
      category: errorMsg["category"] !== undefined ? errorMsg["category"][0] : "",
    });
    setError(null);
  };
  const handleLocationDropdownChange = (option) => {
    console.log(option);
    setSelectedOfficeOption(option);
    setOfficeValue(option.value);
    setOfficeLabel("");
    setFloorSearchUrl(apiUrl + "get_floors/" + option.value);
  };
  const handleFloorDropdownChange = (option) => {
    setSelectedFloorOption(option);
    setFloorValue(option.value);
    setFloorLabel("");
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempBase64FileList = [...base64FileList];
        tempBase64FileList.push(base64String);
        setBase64FileList(tempBase64FileList);
      };
      reader.readAsDataURL(file);
      const tempImageList = [...selectedImageList];
      tempImageList.push(URL.createObjectURL(file));
      setSelectedImageList(tempImageList);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const handleFeatureAdd = () => {
    if (availableFeatureValue !== "") {
      const index = availableFeatureList.findIndex((element) => element === availableFeatureValue);
      if (index === -1) {
        setAvailableFeatureList((prevAvailable) => {
          prevAvailable.push(availableFeatureValue);
          setAvailableFeatureValue("");
          return prevAvailable;
        });
      }
    }
  };

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      fetchOptions();
    }
  };

  return (
    <Container fluid className="GTWalsheimTrial px-0">
      {isOpenDelete && <DeleteModal deleteUrl={`room/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      {isOpen && (
        <div style={modalStyle.overlay}>
          <div style={modalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                  <div style={{ paddingLeft: "4px", fontSize: "20px", fontWeight: "700", color: "#1E1E1E" }}>{roomId !== null && roomId !== "" ? "Edit Meeting Room" : "Meeting room details"}</div>
                </div>
                <SlotCloseIcon style={{ cursor: "pointer" }} onClick={closeModal} />
              </div>
              <div style={{ textAlign: "start", paddingLeft: "4px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E" }} className="custom-radio">
                {roomId !== null && roomId !== "" ? "Now you can edit below details" : "Enter below details to create new office"}
              </div>
              <div style={{ marginTop: "20px" }}>
                <div style={{ position: "relative", width: "629px", height: "100px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px", border: "4px dotted #1E1E1E", borderWidth: "2px", background: "#F3F4F6" }}>
                  {selectedImage === null && (
                    <div>
                      <div>
                        <label onClick={handleFileClick} style={{ cursor: "pointer", textDecoration: "underline", display: "inline-block", color: "#842234", cursor: "pointer" }}>
                          Click here upload
                        </label>
                      </div>
                      <label style={{ fontSize: "13px", fontWeight: "400", color: "#1E1E1E" }}>meeting room image file</label>
                    </div>
                  )}
                  {selectedImage !== null && (
                    <div style={{ position: "relative" }}>
                      <img src={selectedImage} alt="Selected" style={{ width: "629px", height: "100px", objectFit: "cover", borderRadius: "12px" }} />
                      {/*  'cover', 'contain', or 'fill' */}
                      {/*  <div
        style={{
          position: "absolute",
          bottom: "8px",
          right: "8px", 
        }}
      >
        <div style={{ display:'flex',justifyContent:"start", alignItems:"center",}}>
        <div onClick={handleFileClick} style={{cursor: "pointer",fontSize:"11px", fontWeight:"500", width:'72px', height: '24px', borderRadius: '100px',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor:'#FFFFFF', color:'#842234' }}>
        Change
        </div> &nbsp; <ImageRemoveIcon style={{cursor: "pointer",}} onClick={()=>{setSelectedFile(null);setSelectedImage(null);}}/>
        </div>
      </div>  */}
                    </div>
                  )}
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    onChange={handleFileChange}
                    style={{ display: "none" }} // Hide the actual file input
                  />
                </div>
                <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                  {urlImageList.map((urlImage, index) => (
                    <div key={"url-image-" + index} className="mt-3" style={{ position: "relative" }}>
                      <img src={urlImage != null && urlImage !== "" ? urlImage.url : RoomImage} alt="room" style={{ width: "72px", height: "72px", borderRadius: "14px" }} />
                      <div
                        style={{
                          position: "absolute",
                          top: "1px",
                          right: "1px",
                        }}>
                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                          <ImageRemoveIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const tempURLImageList = [...urlImageList];
                              tempURLImageList.splice(index, 1);
                              setUrlImageList(tempURLImageList);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  {selectedImageList.map((baseImage, index) => (
                    <div key={"base-image-" + index} className="mt-3" style={{ position: "relative" }}>
                      <img src={baseImage != null && baseImage !== "" ? baseImage : RoomImage} alt="room" style={{ width: "72px", height: "72px", borderRadius: "14px" }} />
                      <div
                        style={{
                          position: "absolute",
                          top: "1px",
                          right: "1px",
                        }}>
                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                          <ImageRemoveIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const tempImageList = [...selectedImageList];
                              tempImageList.splice(index, 1);
                              setSelectedImageList(tempImageList);
                              const tempBase64FileList = [...base64FileList];
                              tempBase64FileList.splice(index, 1);
                              setBase64FileList(tempBase64FileList);
                              /* setSelectedFile(null);setSelectedImage(null); */
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {roomId !== null && roomId !== "" && (
                  <div className="material-form-group">
                    <input
                      type="text"
                      id="material-input"
                      className="form-control material-input"
                      placeholder=" "
                      readOnly="true"
                      value={codeInputValue}
                      onChange={(event) => {
                        setCodeInputValue(event.target.value); // Update state with input value
                      }}
                    />
                    <label htmlFor="material-input" className="material-label">
                      Code
                    </label>
                  </div>
                )}
                <div className="material-form-group">
                  <input
                    type="text"
                    id="material-input"
                    className="form-control material-input"
                    placeholder=" "
                    value={nameInputValue}
                    onChange={(event) => {
                      setNameInputValue(event.target.value); // Update state with input value
                    }}
                  />
                  <label htmlFor="material-input" className="material-label">
                    Room name
                  </label>
                </div>
                <Form.Text style={{ textAlign: "start" }} className="text-muted">
                  {errorMessage.name !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.name}</div>}
                </Form.Text>

                <Row style={{ marginTop: "16px" }}>
                  <Col>
                    <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={apiUrl + `get_office`} placeholder={"Office"} selectedValue={selectedOfficeLabel} selectedOption={selectedOfficeOption} />
                    <Form.Text style={{ textAlign: "start" }} className="text-muted">
                      {errorMessage.office_id !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.office_id}</div>}
                    </Form.Text>
                  </Col>
                  <Col>
                    <SearchWithAPI onDropdownChange={handleFloorDropdownChange} apiUrl={floorSearchUrl} placeholder={"Floor"} selectedValue={selectedFloorLabel} selectedOption={selectedFloorOption} />
                    <Form.Text style={{ textAlign: "start" }} className="text-muted">
                      {errorMessage.floor_no !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.floor_no}</div>}
                    </Form.Text>
                  </Col>
                </Row>
                <Row style={{ marginTop: "8px" }}>
                  <Col>
                    <div className="material-form-group">
                      <input
                        type="text"
                        id="material-input"
                        className="form-control material-input"
                        placeholder=" "
                        value={categoryInputValue}
                        onChange={(event) => {
                          setCategoryInputValue(event.target.value); // Update state with input value
                        }}
                      />
                      <label htmlFor="material-input" className="material-label">
                        Category
                      </label>
                    </div>
                    <Form.Text style={{ textAlign: "start" }} className="text-muted">
                      {errorMessage.category !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.category}</div>}
                    </Form.Text>
                  </Col>
                  <Col>
                    <div className="material-form-group">
                      <input
                        type="number"
                        id="material-input"
                        className="form-control material-input"
                        placeholder=" "
                        value={capacityInputValue}
                        onChange={(event) => {
                          setCapacityInputValue(event.target.value); // Update state with input value
                        }}
                      />
                      <label htmlFor="material-input" className="material-label">
                        Capacity
                      </label>
                    </div>
                    <Form.Text style={{ textAlign: "start" }} className="text-muted">
                      {errorMessage.floor_count !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.floor_count}</div>}
                    </Form.Text>
                  </Col>
                </Row>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "start", marginTop: "16px" }}>
                  <div style={{ paddingLeft: "4px", fontSize: "14px", fontWeight: "700", color: "#1E1E1E" }}>Available features</div>
                </div>
                <div style={{ position: "relative", height: "40px", marginTop: "8px" }}>
                  {/* Input with Icon */}
                  <div style={{ display: "flex", alignItems: "center", border: "0.7px solid #E5E5E5", borderRadius: "8px", padding: "4px 4px" }}>
                    <Form.Control
                      type="text"
                      placeholder="Type here..."
                      className="feature-input"
                      value={availableFeatureValue}
                      onChange={(event) => {
                        setAvailableFeatureValue(event.target.value); // Update state with input value
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleFeatureAdd();
                        }
                      }}
                    />
                    <div onClick={handleFeatureAdd} style={{ cursor: "pointer", width: "73px", height: "31px", paddingLeft: "16px", paddingRight: "16px", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                      <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Add</div>
                    </div>
                  </div>
                </div>

                <div style={{ fontSize: "14px", fontWeight: "500", color: "#842234", display: "flex", alignItems: "center", justifyContent: "start", marginTop: "16px" }}>Added features : {availableFeatureList.length}</div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {availableFeatureList.map((item, availableIndex) => (
                    <div key={`${availableIndex}-avail`} style={{ height: "36px", marginRight: "16px", marginBottom: "8px", paddingLeft: "8px", paddingRight: "8px", borderRadius: "8px", display: "flex", justifyContent: "start", alignItems: "center", backgroundColor: "#F5F7F9" }}>
                      <label style={{ fontSize: "13.5px", fontWeight: "500", color: "#1E1E1E", display: "flex", justifyContent: "start", alignItems: "center" }}>{item}</label>
                      &nbsp;
                      <SlotCloseIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const updatedItems = [...availableFeatureList];
                          updatedItems.splice(availableIndex, 1);
                          setAvailableFeatureList(updatedItems);
                        }}
                      />
                    </div>
                  ))}
                </div>

                <Row style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop: "8px" }}>
                  <div
                    onClick={(e) => {
                      closeModal();
                    }}
                    style={{ cursor: "pointer", width: "176px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#FFFFFF", border: "0.6px solid #E5E5E5" }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: "#1E1E1E" }}>Cancel</div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (roomId == null || roomId === 0 || roomId === "") {
                        submitOffice();
                      } else {
                        updateOffice();
                      }
                    }}
                    style={{ cursor: "pointer", width: "176px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: "#FFFFFF" }}>Save</div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      <div>
        {/*  <Header selectedTab={'Rooms'}/> */}

        {(checkPermission("Room - Setup", "list_permission") || userType === "A" || userType === "SA") && (
          <Row className="flex-wrap px-3" style={{ height: "calc(100vh - 68px)", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: "center" }}>
            <Col sm={12} xl={8} style={{ padding: "16px", justifyContent: "center" }}>
              <div style={title}>Your all rooms are listed here!</div>
              &nbsp;&nbsp;
              <Form>
                <Row xs={12} style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                  <Col xs={8} xl={9}>
                    <Form.Group style={{ borderRadius: "100px", border: "0.6px solid #E5E5E5", overflow: "hidden" }}>
                      <InputGroup>
                        <Button variant="outline-secondary" style={{ backgroundColor: "#ffffff", border: "none", outline: "none", boxShadow: "none" }}>
                          <SearchIcon />
                        </Button>
                        <Form.Control
                          className="custom-input"
                          type="text"
                          placeholder="Search..."
                          value={searchInputValue}
                          onChange={(event) => {
                            setSearchInputValue(event.target.value);

                            handleSearch(event.target.value);
                          }}
                          style={{ border: "none", outline: "none", boxShadow: "none" }}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col xs={4} xl={2}>
                    {(checkPermission("Room - Setup", "create_permission") || userType === "A" || userType === "SA") && (
                      <div
                        onClick={(e) => {
                          setIsOpen(true);
                        }}
                        style={{ cursor: "pointer", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                        <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Add room</div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Form>
              {roomList.map((item, roomIndex) => (
                <Row onClick={(e) => {

                  navigate("/rooms/view", { state: { id: item["id"], } })
                }} key={`${roomIndex}-room`} style={{ marginTop: "16px", paddingTop: "16px", paddingBottom: "16px", paddingRight: "16px", background: "#ffffff", borderRadius: "24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {/* <Row md={12} className="justify-content-between"> */}
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Col style={{ display: "flex" }}>
                      <img src={item["image"] != null && item["image"] !== "" ? item["image"] : RoomImage} alt="room" style={{ width: "72px", height: "72px", borderRadius: "14px" }} />
                      &nbsp;&nbsp;
                      <div>
                        <div style={roomTitle}>{item["room"]}</div>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                          <div style={{ fontSize: "13px", fontWeight: "500", color: "#842234" }}>{item["capacity"] ?? "0"} Seater</div> &nbsp;&nbsp; <div style={{ width: "3px", height: "3px", backgroundColor: "#D9D9D9" }}></div>&nbsp;&nbsp;
                          <div style={{ fontSize: "13px", fontWeight: "400", color: "#81878C" }}>{item["category"] ?? ""}</div>
                        </div>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                          <div style={{ fontSize: "13px", fontWeight: "400", color: "#21272C", padding: "4px", background: "#F5F7F9", borderRadius: "6px" }}>{item["office"] ?? ""}</div> &nbsp;&nbsp; <div style={{ width: "3px", height: "3px", backgroundColor: "#D9D9D9" }}></div>&nbsp;&nbsp;
                          <div style={{ fontSize: "13px", fontWeight: "400", color: "#21272C", padding: "4px", background: "#F5F7F9", borderRadius: "6px" }}>{item["floor_label"] ?? ""}</div>
                        </div>
                      </div>
                    </Col>

                    <div key={`${roomIndex}-more`} style={{ position: "relative" }}>
                      <MoreIcon
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation()
                          setAlertIndex(roomIndex === alertIndex ? null : roomIndex);
                        }}
                      />
                      {alertIndex === roomIndex && (
                        <div ref={alertRef} style={{ position: "absolute", top: "40px", left: "50%", transform: "translateX(-50%)", backgroundColor: "#ffffff", color: "#1E1E1E", padding: "16px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", zIndex: 1, alignItems: "end" }}>
                          <div
                            onClick={(e) => {
                              e.stopPropagation()
                              editOffice(item["id"]);
                            }}
                            style={{ cursor: "pointer", width: "150px", height: "36px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "start" }}>
                            Edit
                          </div>
                          <div
                            onClick={(e) => {
                              e.stopPropagation()
                              setDeleteId(item.id);
                            }}
                            style={{ cursor: "pointer", width: "150px", height: "36px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "start" }}>
                            Delete
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Row>
              ))}
              {roomList.length === 0 && (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <NoRecordsFound />
                  <div style={{ marginTop: "8px", fontSize: "16px", fontWeight: "500", color: "#212129" }}>No records found</div>
                  <div style={{ fontSize: "13px", fontWeight: "400", color: "#8790A1" }}>Looks like you haven’t any data to show</div>
                </div>
              )}
              {roomList.length > 0 && (<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ fontFamily: "GT Walsheim Trial Bd", fontSize: "12px", fontWeight: "500", color: "#172b4d" }}>Records per page :</div>
                  <select
                    className="select3"
                    id="perpage"
                    value={itemsPerPage}
                    onChange={(event) => {
                      setItemsPerPage(event.target.value);
                    }}
                    style={{ cursor: "pointer", fontFamily: "GT Walsheim Trial Rg", fontSize: "12px", fontWeight: "700", lineHeight: "18.9px", color: "#172b4d", borderRadius: "6px", border: "0.6px solid #E5E5E5", padding: "8px 7px", backgroundColor: "#FFFFFF" }}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>

                <div style={{ marginTop: '12px' }}>
                  <ReactPaginate previousLabel={<img src={lar} style={{ width: "12px", height: "12px" }} alt="previous" />} nextLabel={<img src={rar} style={{ width: "12px", height: "12px" }} alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
                </div>
              </div>)}
            </Col>
          </Row>
        )}
      </div>

      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </Container>
  );
}
